module.exports = function() {
  return new Worker(__webpack_public_path__ + "7deeebf3e092890c0077.worker.js");
};